import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AclGuard } from '../../core/_guards/acl/guard/acl.guard';
import { EmailTrackerComponent } from './pages/tracker/tracker.component';
import { ArchiverTrackerComponent } from './pages/archiver/archiver.component';

const emailRoutes: Routes = [
  {
    path: 'email-tracker',
    component: EmailTrackerComponent,
    canActivate: [AclGuard],
    data: {
      title: 'Email Tracker | Gatefy',
      acl: {
        locale: 'shallowModule',
        permission: 'emailTrackerMenu',
      },
    },
  },
  {
    path: 'email-archiver',
    component: ArchiverTrackerComponent,
    canActivate: [AclGuard],
    data: {
      title: 'Archiver | Gatefy',
      acl: {
        locale: 'shallowModule',
        permission: 'emailArchiverMenu',
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(emailRoutes)],
  exports: [RouterModule],
})
export class EmailRoutingModule {
}
